module.exports = __webpack_public_path__ + "images/kaitori_bonus_lp/step-2-img-sp@2x_a82d766dc1701f9a590fd8eb41de2642.png";